

import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { authorizedRequest } from '../../api/authorizedRequest';
import { useAuth } from '../../context/AuthContext';
import './Profile.css';
import { Link } from 'react-router-dom';

interface DecodedToken {
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string | string[];
  exp: number;
}

interface EmployeeProfile {
    id: string;
    name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    balance: number;
    accountType: string | null;
    bankAccount: string | null;
    ssn: string;
    isActive: boolean;
    printStub: boolean;
    userId: string;
    roles: string[];
}

const Profile = () => {
  const { token } = useAuth();
  const [employee, setEmployee] = useState<EmployeeProfile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        if (!token) {
          setError('No token found');
          setLoading(false);
          return;
        }

        const decodedToken = jwtDecode<DecodedToken>(token);
        const userId = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];

        const response = await authorizedRequest({
          url: `/employee/GetCurrentUser`,
          method: 'GET',
        });

        setEmployee(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch employee data');
        setLoading(false);
      }
    };

    fetchEmployeeData();
  }, [token]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!employee) {
    return <div>No employee data found.</div>;
  }

  const fullAddress = [employee.address1, employee.address2, employee.city, employee.state, employee.zip].filter(Boolean).join(', ');

  return (
      <div className="pd-ltr-20 xs-pd-20-10">
          <div className="min-height-200px">
              <div className="page-header">
                  <div className="row">
                      <div className="col-md-12 col-sm-12">
                          <div className="title">
                              <h4>Profile</h4>
                          </div>
                          {/* <nav aria-label="breadcrumb" role="navigation">
                              <ol className="breadcrumb">
                                  <li className="breadcrumb-item">
                                      <a href="index.html">Home</a>
                                  </li>
                                  <li className="breadcrumb-item active" aria-current="page">
                                      Profile
                                  </li>
                              </ol>
                          </nav> */}
                      </div>
                  </div>
              </div>
              <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-30">
                      <div className="pd-20 card-box height-100-p">
                          <div className="profile-photo">
                              <img
                                  src="/images/photo1-2.png"
                                  alt="profile"
                                  className="avatar-photo"
                              />
                          </div>
                          <h5 className="text-center h5 mb-0">{employee.name}</h5>
                          <p className="text-center text-muted font-14">
                              {employee.roles.join(', ')}
                          </p>
                      </div>
                  </div>
                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 mb-30">
                      <div className="card-box height-100-p pd-20">
                          <h4 className="mb-20">Employee Details</h4>
                          <div className="profile-info-big">
                              <div className="row">
                                  <div className="col-md-4">
                                      <ul>
                                          <li><span>ID:</span> {employee.id}</li>
                                          <li><span>Address:</span> {fullAddress}</li>
                                           <li><span>Active:</span> {employee.isActive ? 'Yes' : 'No'}</li>
                                      </ul>
                                  </div>
                                  {/* <div className="col-md-4">
                                      <ul>
                                          <li><span>SSN (Last 4):</span> {employee.ssn}</li> 
                                           <li><span>User ID:</span> {employee.userId}</li>
                                          <li><span>Balance:</span> ${employee.balance.toFixed(2)}</li>
                                      </ul>
                                  </div> */}
                                  <div className="col-md-4">
                                      <ul>
                                          <li><span>Account Type:</span> {employee.accountType || 'N/A'}</li>
                                          <li><span>Bank Account:</span> {employee.bankAccount || 'N/A'}</li>
                                          <li><span>Print Stub:</span> {employee.printStub ? 'Yes' : 'No'}</li>
                                          <li>
                                              <Link to="/reset-password" className="btn btn-secondary btn-sm">Reset Password</Link>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
};

export default Profile;
